import gql from 'graphql-tag';

export const PLAN_ITEM_FIELDS = gql`
	fragment PlanItemFields on PlanItem {
		_id
		createdDate
		createdById
		lastModifiedDate
		lastModifiedById
		orgId
		versionId
		unique
		imageUrl
		level
		screenshotUrl
		titleLabel
		titleNumber
		pageNum
		scale
		sortOrder
		order
		name
		category
		secondCategory
		dpi
		cropBoxWidth
		cropBoxHeight
		system
		isHide
		planId
		levelId
		layerSettings
	}
`;
